import React from "react";
import { Container } from "reactstrap";
//@ts-ignore
import logo from "../../assets/logo-white.png";
import { Link } from "react-router-dom";
import { FaMailBulk, FaPhone } from "react-icons/fa";

export const Imprint = () => {
  document.title = "Casino24 - Imprint";
  return (
    <Container
      fluid
      className="m-0 flex flex-col min-h-fit w-full items-center text-white"
    >
      <section className="w-full lg:w-[75%] lg:mt-[2rem] mb-1">
        <Link to="/">
          <img
            src={logo}
            alt="Casino24"
            className="object-cover w-[10rem] lg:w-[15rem] my-3 cursor-pointer"
          />
        </Link>
      </section>
      <section className="flex flex-col w-[90%] lg:w-[50%] xl:w-[37%] mt-2 mb-5 text-justify text-md ">
        <h2 className="text-center font-bold text-2xl xl:text-3xl mt-4">
          Imprint
        </h2>
        <p className="mt-5 mb-3 font-bold text-lg">Legal Compay Informations</p>
        <p className="mb-1 font-bold">Hype Grow, Unipessoal Lda</p>
        <p className="mb-1">
          Rua Dr. António Loureiro Borges, n.º 1, 2nd Floor
        </p>
        <p className="mb-1">1495-131 Algés </p>
        <p className="mb-5">Portugal</p>
        <p className="mb-1 flex items-center">
          <FaPhone className="mr-3 text-red-500" />
          +49 174 4149494
        </p>
        <p className="mb-1 flex items-center">
          <FaMailBulk className="mr-3 text-blue-500" />
          <i>info@casinob8.com</i>
        </p>
      </section>
    </Container>
  );
};
